/* eslint-disable no-unused-vars */
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { Button } from "@mui/material";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { SyncUtils } from "../../utils/SyncUtils";
import { v4 as uuidv4 } from "uuid";
import { StringUtils } from "../../utils/StringUtils";
import API from "../../utils/API";
import PDatePicker from "../../components/pos/PDatePicker";
import GenericReportViewer from "../reports/GenericReportViewer";
import {
  blue,
  brown,
  green,
  orange,
  purple,
  red,
  teal,
  yellow,
  grey,
} from "@mui/material/colors";

import { withStyles } from "@mui/styles";

const useStyles = makeStyles({});

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 10,
          marginLeft: 2,
        },
      },
    },
  },
});

const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.85rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default function SearchBar(props) {
  const { t } = useTranslation();
  const translate = t;
  const [autoFocus, setAutoFocus] = useState(true);
  const [windowTitle, setWindowTitle] = useState(translate("Customer Lookup"));

  const [customerName, setCustomerName] = useState("");
  const [customerNameError, setCustomerNameError] = useState("");

  const [customerId, setCustomerId] = useState("");
  const [customerCode, setCustomerCode] = useState("");

  const [dueAmount, setDueAmount] = useState("");
  const [loayalityPoints, setLoyalityPoints] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerPhoneError, setCustomerPhoneError] = useState("");

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmContext, setConfirmContext] = useState([]);
  const [saveLabel, setSaveLabel] = useState("Select");
  const [customerLookupValue, setCustomerLookupValue] = useState();

  const [customerBean, setcustomerBean] = useState(null);

  const classes = useStyles();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  useEffect(() => {
    let dt = new Date();
    let startDate = new Date(dt.getFullYear(), dt.getMonth(), 1);
    setEndDate(StringUtils.formatDate(dt, 2));
    setStartDate(StringUtils.formatDate(startDate, 2));
  }, []);

  useEffect(() => {
    if (props.customerBean) populateCustomer(props.customerBean);
  }, [props.customerBean]);

  async function getOptionsAsync(inputValue, callback) {
    let dbData = await db.customer
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("custId")
      .startsWithIgnoreCase(inputValue)
      .or("micrCode")
      .startsWithIgnoreCase(inputValue)
      .or("mobile")
      .startsWithIgnoreCase(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      if (count < 10) {
        let val = {
          id: dbData[i].id,
          name: dbData[i].name,
          custId: dbData[i].custId,
          micrCode: dbData[i].micrCode,
          bean: dbData[i],
        };
        arr.push(val);
        count++;
      } else {
        break;
      }
    }

    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.custId}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.micrCode}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  function onCloseWindow() {
    props.setShowCustomerLookupWindow(false);
  }

  function customerSelected(e) {
    if (e.keyCode == 13 && !autoFocus) {
      console.log("Customer Selected");
      onSave();
    }
  }

  function isDataChanged() {
    if (props.customerId == "" && (customerId || customerId != "")) return true;
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "no") {
      props.setShowCustomerLookupWindow(false);
      setConfirmContext([]);
    }
  }

  async function onSave() {
    console.log("onSave");
    if (customerId === "" || customerId === null) {
      //See If We can Create
      let dbData;
      if (customerName != "" || customerPhone != "") {
        if (customerPhone != "" || customerPhone != "") {
          dbData = await db.customer
            .where({ name: customerName, mobile: customerPhone })
            .limit(10)
            .toArray();
        } else {
          dbData = await db.customer
            .where({ name: customerName })
            .limit(10)
            .toArray();
        }

        if (dbData.length > 0) {
          props.setAlert({
            show: true,
            title: translate("Already Exist"),
            message: translate("Customer Already Exist"),
            type: "failure",
          });
          return;
        }

        let saveObject = Object.create(null);
        saveObject = createPayload("create", saveObject);
        db.table("customer").put(saveObject);
        SyncUtils.createSyncMeta("CREATE", saveObject["id"], "customer");
        props.setCustomerBean(saveObject);
      } else {
        setConfirmOpen(true);
        setConfirmContext({
          title: translate("Do you want to continue"),
          message: translate("No Customer is Selected"),
          type: "warning",
          open: true,
          yes: true,
          no: true,
        });
        return;
      }
    } else if (saveLabel === "Save and Select") {
      let data = await db.customer.where("id").equals(customerId).toArray();

      let saveObject = createPayload("update", data[0]);
      db.table("customer").put(saveObject);
      SyncUtils.createSyncMeta("UPDATE", saveObject["id"], "customer");
      props.setCustomerBean(saveObject);
    } else if (saveLabel === "Select") {
      let data = await db.customer.where("id").equals(customerId).toArray();
      props.setCustomerBean(data[0]);
    }

    props.setShowCustomerLookupWindow(false);
  }

  function createPayload(mode, saveObject) {
    saveObject["name"] = customerName;
    saveObject["mobile"] = customerPhone;
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = uuidv4();
      saveObject["intVersion"] = 0;
      saveObject["custId"] = "AUTO";
      saveObject["micrCode"] = "AUTO";
      saveObject["creditCustomer"] = false;
      saveObject["emailInvoice"] = false;
    }
    return saveObject;
  }
  async function populateCustomer(data) {
    setcustomerBean(data);
    setCustomerId(data.id);
    setCustomerName(data.name);
    setCustomerCode(data.custId);
    setLoyalityPoints(data.loayalityPoints);
    setCustomerPhone(data.mobile);
    setDueAmount("");
    console.log(data);
  }

  async function populateBalance(data, purpose) {
    let res = await API.get("/api/v1/currentfinancialyear");

    let payload = {
      template: "reports/Accounts/7_ledgers",
      rawDataV2: true,
      paramList: [
        {
          key: "startDate",
          value: purpose == "forBalance" ? "2050-01-01" : startDate,
          label: "From",
          labelValue: purpose == "forBalance" ? "2050-01-01" : startDate,
        },
        {
          key: "endDate",
          value: purpose == "forBalance" ? "2050-01-01" : endDate,
          label: "To",
          labelValue: purpose == "forBalance" ? "2050-01-01" : endDate,
        },
        {
          key: "ledgerId",
          value: data.ledgerId,
          label: data.ledgerId,
          labelValue: purpose == "forBalance" ? "T4" : data.name,
        },
        {
          key: "financialYear",
          value: res.data.id,
          label: "Year",
          labelValue: "2021",
        },
      ],
      pluginMode: "v2",
    };
    if (purpose == "forBalance" && data.creditCustomer) {
      let result = await API.post("/report/generate", payload);
      if (result.data.closingBalance) {
        setDueAmount(result.data.closingBalance);
      }
    } else {
      setDueAmount("");
    }
    if (purpose == "forReport") {
      biRef.genericReportView.showGenericReportViewer(
        payload.template,
        payload.paramList,
        "Customer Transaction",
        payload.pluginMode
      );
    }
  }

  var biRef = {};

  const customerLookupChanged = (newValue) => {
    setAutoFocus(false);
    populateCustomer(newValue.value.bean);
    setCustomerLookupValue({ label: null, value: null });
    setSaveLabel(translate("Select"));
  };

  function resetFields() {
    setCustomerId("");
    setcustomerBean(null);
    setCustomerName("");
    setCustomerCode("");
    setDueAmount("");
    setLoyalityPoints("");
    setCustomerPhone("");
  }

  const content = (
    <ThemeProvider theme={theme}>
      <div style={{ paddingLeft: 10, paddingRight: 10, height: 400 }}>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <AsyncSelect
              formatOptionLabel={formatOptionLabel}
              autoFocus={autoFocus}
              onFocus={() => setAutoFocus(true)}
              blurInputOnSelect
              components={{ formatOptionLabel }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999,
                }),
                marginRight: "10px",
              }}
              placeholder={translate(
                props.prompt ? props.prompt : "Customer Lookup"
              )}
              loadOptions={getOptions}
              onChange={customerLookupChanged}
              /*onKeyDown={(e) => {
            console.log("KEY");
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}*/
              value={customerLookupValue}
            />
          </Grid>
          <Grid item xs={12} sm={18}>
            <table width="100%">
              <tbody>
                <tr>
                  <td>{translate("Name")}</td>
                  <td>
                    <PText
                      value={customerName}
                      error={customerNameError}
                      onChange={(e) => {
                        setSaveLabel("Save and Select");
                        setCustomerName(e.target.value);
                      }}
                    ></PText>
                  </td>
                </tr>
                <tr>
                  <td>{translate("Contact")}</td>
                  <td>
                    <PText
                      value={customerPhone}
                      error={customerPhoneError}
                      onChange={(e) => {
                        setSaveLabel("Save and Select");
                        setCustomerPhone(e.target.value);
                      }}
                    ></PText>
                  </td>
                </tr>
                <tr>
                  <td>{translate("Customer Code")}</td>
                  <td>
                    <PText
                      value={customerCode}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                </tr>
                <tr>
                  <td>{translate("Loyalty Points")}</td>
                  <td>
                    <PText
                      value={loayalityPoints}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                </tr>

                <tr>
                  <td>{translate("Due Amount")}</td>
                  <td>
                    <table width={"100%"}>
                      <tbody>
                        <tr>
                          <td>
                            <PText
                              value={dueAmount}
                              InputProps={{ readOnly: true }}
                            ></PText>
                          </td>
                          <td>
                            <ActionButton
                              style={{
                                backgroundColor: blue[500],
                              }}
                              disabled={
                                customerBean == null ||
                                !customerBean.creditCustomer
                              }
                              onClick={(e) => {
                                populateBalance(customerBean, "forBalance");
                              }}
                            >
                              {translate("Get Balance")}
                            </ActionButton>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td>Start Date</td>
                  <td>
                    <PDatePicker
                      value={startDate}
                      type="date"
                      onChange={(value) => {
                        setStartDate(StringUtils.formatDate(value.$d, 2));
                      }}
                    ></PDatePicker>
                  </td>
                </tr>

                <tr>
                  <td>End Date</td>
                  <td>
                    <PDatePicker
                      value={endDate}
                      type="date"
                      onChange={(value) => {
                        setEndDate(StringUtils.formatDate(value.$d, 2));
                      }}
                    ></PDatePicker>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <ActionButton
                      style={{
                        backgroundColor: blue[500],
                      }}
                      disabled={customerBean == null}
                      onClick={(e) => {
                        populateBalance(customerBean, "forReport");
                      }}
                    >
                      {translate("View Report")}
                    </ActionButton>
                  </td>
                </tr>

                {/*<tr>
                  <td>{translate("Last Purchase Date")}</td>
                  <td>
                    <PText
                      value={lastPurchaseDate}
                      InputProps={{ readOnly: true }}
                    ></PText>
                  </td>
                </tr>*/}
              </tbody>
            </table>
          </Grid>
        </Grid>
      </div>
    </ThemeProvider>
  );

  function onNewClicked() {
    resetFields();
  }

  return (
    <div>
      <PDialog
        content={content}
        title={windowTitle}
        maxWidth={"sm"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        custumClose={true}
        onSave={onSave}
        onKeyDown={customerSelected}
        saveLabel={translate(saveLabel)}
        isDataChanged={isDataChanged}
        //onDelete={onDelete}
        showLeftButton={true}
        leftButtonLabel={translate("New")}
        onLeftButtonCLicked={onNewClicked}
      ></PDialog>

      {confirmOpen && (
        <PConfirm
          fullWidth={true}
          maxWidth="xs"
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
    </div>
  );
}
